import { useMemo } from "react";
import useAmpolServiceDataStore from "@/use-ampol-service-data-store";
import useIndicationStore from "@/use-indication-store";
import { AmpolService } from "./types";

const useIndication = () => {
  const indication = useIndicationStore((store) => store.indication);
  const indicatedIds = useMemo(
    () => (indication != null ? indication.$ids : []),
    [indication]
  );

  const ampolServices = useAmpolServiceDataStore((store) => store.services);

  const indicatedAmpolServices = useMemo(() => {
    return (indication != null ? indication.$ids : [])
      .map((i) => (ampolServices ?? new Map<string, AmpolService>()).get(i))
      .filter((f) => f != null);
  }, [ampolServices, indication]);

  return { ampolServices: indicatedAmpolServices, indication, indicatedIds };
};

export default useIndication;
